import axios from 'axios';

const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL || '/api';
};

const api = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 10000,
  headers: {
    Accept: 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      // Must clear BOTH localStorage AND zustand persist storage to prevent infinite reload loop.
      // If we only clear localStorage, zustand persist ('auth-storage' key) rehydrates
      // the old expired token on next page load, causing an infinite redirect loop.
      try {
        const { useAuthStore } = await import('../stores/authStore');
        const authStore = useAuthStore.getState?.();
        if (authStore?.logout) {
          // logout() clears zustand state (which also clears the persisted storage)
          // and redirects to login
          authStore.logout(true);
          return Promise.reject(error);
        }
      } catch (e) {
        // Fallback if store import fails
      }

      // Fallback: clear everything manually
      localStorage.removeItem('token');
      localStorage.removeItem('token_created_at');
      localStorage.removeItem('user');
      localStorage.removeItem('auth-storage'); // Clear zustand persist!
    }
    return Promise.reject(error);
  },
);

export default api;
